import { render } from "./AssociationManagement.vue?vue&type=template&id=10974066&scoped=true"
import script from "./AssociationManagement.vue?vue&type=script&lang=js"
export * from "./AssociationManagement.vue?vue&type=script&lang=js"

import "./AssociationManagement.vue?vue&type=style&index=0&id=10974066&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10974066"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QPopupProxy,QCard,QCardSection,QIcon,QFile,QList,QItem,QItemSection,QSpace,QInput,QLinearProgress,QBanner,QDialog,QSelect,QBtnToggle,QColor});
